type NotificationIconProps = {
  color?: string;
  size?: string;
};

export const NotificationIcon = ({
  color = "#062e5e",
  size = "22",
}: NotificationIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 22 22"
  >
    <path
      d="m222.022 1168.53-1.014-1.692a3.891 3.891 0 0 1-.554-2v-2.408a6.183 6.183 0 0 0-12.366 0v2.408a3.9 3.9 0 0 1-.554 2l-1.014 1.692a1.879 1.879 0 0 0 1.612 2.845h3.648c-.007.077-.03.151-.03.229a2.521 2.521 0 0 0 5.042 0c0-.078-.023-.152-.03-.229h3.648a1.877 1.877 0 0 0 1.611-2.845zm-6.605 3.074a1.146 1.146 0 0 1-2.292 0 1.13 1.13 0 0 1 .03-.229h2.231a1.132 1.132 0 0 1 .031.225zm5.433-1.861a.5.5 0 0 1-.44.256h-12.278a.5.5 0 0 1-.434-.763l1.014-1.692a5.264 5.264 0 0 0 .75-2.709v-2.408a4.808 4.808 0 0 1 9.616 0v2.408a5.273 5.273 0 0 0 .75 2.709l1.014 1.692a.493.493 0 0 1 .008.507z"
      transform="translate(-203.271 -1154.187)"
      fill={color}
    />
  </svg>
);
